import { isArray, isObject, isNumber, mapKeys, camelCase, round } from 'lodash-es';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import utc from 'dayjs/plugin/utc';
import { referralUrlParam } from './consts.ts';

dayjs.extend(duration);
dayjs.extend(utc);

export const wait = async (time: number) => new Promise((res) => setTimeout(res, time));

export const formatSeconds = (seconds: number): string => {
  const time = dayjs.duration(seconds, 'seconds');
  const minutes = time.minutes();
  const secs = time.seconds();

  return `${minutes}:${secs.toString().padStart(2, '0')}`;
};

export const convertObjectKeysOrArrayValuesToCamelCase = <T extends Record<string, $TSFixMe>>(
  obj: T
): ConvertObjectKeysToCamelCase<T> => {
  if (isArray(obj)) {
    return obj.map((item) => convertObjectKeysOrArrayValuesToCamelCase(item)) as unknown as T;
  } else if (isObject(obj)) {
    const camelCasedObject = mapKeys(obj, (_value, key) => camelCase(key));

    return Object.entries(camelCasedObject).reduce(
      (result, [key, value]) => {
        result[key] =
          isArray(value) || isObject(value)
            ? convertObjectKeysOrArrayValuesToCamelCase(value)
            : value;
        return result;
      },
      {} as Record<string, $TSFixMe>
    ) as T;
  } else {
    return obj as T;
  }
};
export const calculateDuration = (startAt?: number, endAt?: number) => {
  if (!(startAt && endAt)) return 0;

  const startTime = dayjs(startAt);
  const endTime = dayjs(endAt);

  const durationInSeconds = endTime.diff(startTime, 'second');

  return Math.max(0, durationInSeconds);
};

export const getGrowthRenderValue = (
  rawGrowth: unknown,
  placeholder = '',
  floatDigits?: number
) => {
  if (!isNumber(rawGrowth)) return placeholder;
  const growth = isNumber(floatDigits) ? round(rawGrowth, floatDigits) : rawGrowth;
  return growth === 0 ? `${growth}` : growth > 0 ? `+${growth}↑` : `${growth}↓`;
};

export const isBigInt = (value: unknown): value is bigint => typeof value === 'bigint';

export const getRefCodeLinkUrl = (referralCode: Maybe<string>) => {
  if (!referralCode) return '';
  return `${window.location.origin}/game?${referralUrlParam}=${referralCode}`;
};

export const formatEthAmount = (amount: number) => {
  return amount === 0 ? '0' : amount.toFixed(8);
};

export const typedObjKeys = <T extends object>(obj: T): (keyof T)[] =>
  Object.keys(obj) as (keyof T)[];

export const typedObjEntries = <T extends object>(obj: T): Array<[keyof T, T[keyof T]]> => {
  return Object.entries(obj) as Array<[keyof T, T[keyof T]]>;
};
